import styled from 'styled-components';

const StyledWrapper = styled.div`
	position: absolute;
	top: 0;
	width: 100%;
	height: 100%;
	background-color: #111111;
	transition: opacity 0.3s ease;

	&.apps-enter {
		opacity: 0;
	}

	&.apps-enter-active,
	&.apps-enter-done,
	&.apps-exit {
		opacity: 1;
	}

	&.apps-exit-active {
		opacity: 0;
	}
`;

const StyledMenu = styled.div<{ $hidden?: boolean }>`
	position: absolute;
	bottom: 50px;
	left: 50%;
	transform: translateX(-50%);
	z-index: 3;
	display: flex;
	align-items: center;
	gap: 30px;
	width: auto;
	height: 60px;
	padding: 0 30px;
	background: linear-gradient(
			180deg,
			rgba(255, 255, 255, 0) 79.81%,
			rgba(255, 255, 255, 0.05) 100%
		),
		#111111;
	border: 1px solid rgba(255, 255, 255, 0.1);
	box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.5);
	border-radius: 30px;
	opacity: ${({ $hidden }) => ($hidden ? 0 : 1)};
	transition: opacity 0.3s ease;
	pointer-events: ${({ $hidden }) => ($hidden ? 'none' : 'auto')};
`;

const StyledIconWrapper = styled.div<{ $active?: boolean }>`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 30px;
	height: 30px;
	cursor: pointer;

	.img-icon {
		transition: background-color 0.3s ease;
		background-color: ${({ $active }) =>
			$active ? '#C71E1E' : 'rgba(255, 255, 255, 0.5)'};
	}

	&:hover {
		.img-icon {
			background-color: #ffffff;
		}
	}
`;

export { StyledIconWrapper, StyledMenu, StyledWrapper };
